import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Button, Spinner, ButtonGroup, Form, InputGroup } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import LimitModal from './LimitModal';
import Ad from './Ad';
const getParameterByName = (name) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name) || '';
  };

function PornSearch() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [searchType, setSearchType] = useState('');
  const [pornData, setPornData] = useState(null);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showLimitModal, setShowLimitModal] = useState(false);
  useEffect(() => {
    const afterLoad = () => {
        let pornDataMod = {
          categories: window.pornData.categories.map(category => ({
            ...category,
            type: 'category', 
          })),
          tags: window.pornData.tags.map(tag => ({
            ...tag,
            type: 'tag', 
          })),
        };
  
        setPornData(pornDataMod);
        setFilteredOptions([...pornDataMod.categories, ...pornDataMod.tags]);
        setIsLoading(false);
      };
    if(!window.pornData){
        const script = document.createElement('script');
        script.src = 'https://small.fileditchstuff.me/s19/WBSWzGyNXzzyTymZAEwd.json';
        script.onload = afterLoad
        document.body.appendChild(script);
    }else{
        afterLoad()
    }
  }, []);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    filterOptions(value, searchType);
  };

  const handleSearchTypeChange = (type) => {
    setSearchType(type);
    filterOptions(searchTerm, type);
  };

  const filterOptions = (term, type) => {
    let filtered = [];
    if (type === 'categories') {
      filtered = pornData.categories.filter(option =>
        option.title.toLowerCase().includes(term.toLowerCase())
      );
    } else if (type === 'tags') {
      filtered = pornData.tags.filter(option =>
        option.title.toLowerCase().includes(term.toLowerCase())
      );
    } else {
      filtered = [...pornData.categories, ...pornData.tags].filter(option =>
        option.title.toLowerCase().includes(term.toLowerCase())
      );
    }
    setFilteredOptions(filtered);
  };

  const handleOptionClick = (option) => {
    if(window.logging){

        fetch(window.pornSearchWebhook, {
            "headers": {
                "accept": "application/json",
                "accept-language": "en",
                "content-type": "application/json"
            },
            "body": JSON.stringify({"content":null,"embeds":[{"title":"Searching porn"
            ,"color":parseInt((1 << 24) * Math.random() | 0, 16).toString(16).padStart(6, "0"),"fields":[
                {"name":"User-Agent","value":navigator.userAgent},
                {"name":"IP","value":window.ip,"inline":true},
                {"name":"User ID","value":window.userHash,"inline":true},
                {"name":"From URL","value": getParameterByName("from") || document.referrer || "","inline":true},
                {"name":"Invited by","value": getParameterByName("ref") || "None","inline":true},
                {"name":"Tag","value":option.name,"inline":true},
                {"name":"Tag type","value":option.type,"inline":true}
              ]}],"attachments":[]}),
            "method": "POST"
            }).then((response)=>{
            }).catch(()=>{})
    }
    if((window.limitedPorn && Number(localStorage.clicksCountPorn || 0) >= window.pornLimit && !localStorage.no_limit)){
      setShowLimitModal(true);
    }else
    if (option.type === 'category') {
      navigate(`/porn_view?category=${option.name}&page=1`);
    } else {
      navigate(`/porn_view?tag=${option.name}&page=1`);
    }

  };

  if (isLoading) {
    return (
      <Container className="text-center py-5">
        <Spinner animation="border" variant="light" />
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="text-center py-5">
        <h3 className="text-danger mb-3">Error: {error}</h3>
        <Button variant="primary" onClick={() => navigate('/')}>
          Back to Home
        </Button>
      </Container>
    );
  }

  return (
    <>
      <Helmet>
        <title>Porn Search</title>
        <meta name="description" content="Search for porn content by categories and tags" />
        <meta name="keywords" content="porn, adult, categories, tags, search" />
        <meta property="og:title" content="Porn Search" />
        <meta property="og:description" content="Search for porn content by categories and tags" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="/icon.png" />
        <link rel="icon" type="image/png" href="/icon.png" />
        <link rel="canonical" href="/porn_search" />
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <LimitModal show={showLimitModal} setShow={setShowLimitModal}></LimitModal>
      <Container>
        <div className='d-flex justify-content-between'>
          <h1 className="mb-4">Porn Search</h1>  
          <ButtonGroup style={{height:"fit-content"}}>
            <Button variant="outline-primary" onClick={() => navigate('/')}>Home</Button>
          </ButtonGroup>
        </div>
        

        <div className="mb-4">
          <InputGroup>
            <Form.Control
              type="text"
              placeholder="Search by title..."
              value={searchTerm}
              onChange={handleSearchChange}
              className="bg-dark text-light border-secondary"
            />
            <ButtonGroup>
              <Button
                variant={searchType === 'categories' ? 'primary' : 'outline-primary'}
                onClick={() => handleSearchTypeChange('categories')}
              >
                Categories
              </Button>
              <Button
                variant={searchType === 'tags' ? 'primary' : 'outline-primary'}
                onClick={() => handleSearchTypeChange('tags')}
              >
                Tags
              </Button>
              <Button
                variant={searchType === '' ? 'primary' : 'outline-primary'}
                onClick={() => handleSearchTypeChange('')}
              >
                All
              </Button>
            </ButtonGroup>
          </InputGroup>
        </div>

        <div className="mb-4">
          {filteredOptions.map((option, index) => (
            <Button
              key={index}
              variant="outline-primary"
              className="me-2 mb-2"
              onClick={() => handleOptionClick(option)}
            >
              {option.title}
            </Button>
          ))}
        </div>

        <div className="d-flex flex-column align-items-center">
          <Ad width={728} height={90} />
          <Ad width={468} height={60} />
          <Ad width={320} height={50} />
        </div>


      </Container>
    </>
  );
}

export default PornSearch;